module.exports = __webpack_public_path__ + "img/EOTP_trophy.f930df7f.svg";